import React from 'react';

import { bemBlock, Link } from '@neptune/shared/venus-ui';

import { getPulseCheckSurveyEnabled } from 'common/featureFlag';

import config from 'config';

import './PulseCheckSurveyDot.less';

export const PULSE_CHECK_SURVEY_URL =
  'https://microsoft-si.slack.com/archives/C0AJEQDQW95/xx';

export const PULSE_CHECK_SURVEY_LINK_LABEL = 'Rate Neptune';

export const PULSE_CHECK_SURVEY_CLICKED_STORAGE_KEY = 'neptune-pulse-check-survey-clicked';

const DEFAULT_PULSE_CHECK_SURVEY_CAMPAIGN_ID = 'default';

const block = bemBlock('pulse-check-survey-dot');

export const PulseCheckSurveyDot: React.FC = () => {
  const [wasClicked, setWasClicked] = React.useState(hasPulseCheckSurveyBeenClicked);

  const handleClick = () => {
    persistPulseCheckSurveyClick();
    setWasClicked(true);
  };

  if (!getPulseCheckSurveyEnabled() || wasClicked) {
    return null;
  }

  return (
    <div className={block()} data-role="pulse-check-survey-prompt">
      <span className={block('dot')} />
      <Link
        className={block('link')}
        data-role="pulse-check-survey-link"
        external
        href={PULSE_CHECK_SURVEY_URL}
        onClick={handleClick}
      >
        {PULSE_CHECK_SURVEY_LINK_LABEL}
      </Link>
    </div>
  );
};

function hasPulseCheckSurveyBeenClicked(): boolean {
  try {
    return isPulseCheckSurveyClickedForCampaign(
      window.localStorage.getItem(PULSE_CHECK_SURVEY_CLICKED_STORAGE_KEY),
    );
  } catch {
    return false;
  }
}

function persistPulseCheckSurveyClick(): void {
  try {
    window.localStorage.setItem(
      PULSE_CHECK_SURVEY_CLICKED_STORAGE_KEY,
      getPulseCheckSurveyCampaignId(),
    );
  } catch {
    return;
  }
}

function getPulseCheckSurveyCampaignId(): string {
  return config.pulseCheckSurveyCampaignId || DEFAULT_PULSE_CHECK_SURVEY_CAMPAIGN_ID;
}

// Store the clicked campaign id as the value under one stable key. Bump
// pulseCheckSurveyCampaignId in config to show the prompt again without a code release.
export function isPulseCheckSurveyClickedForCampaign(
  storedCampaignId: string | null,
  campaignId = getPulseCheckSurveyCampaignId(),
): boolean {
  return (
    storedCampaignId === campaignId ||
    (storedCampaignId === 'true' && campaignId === DEFAULT_PULSE_CHECK_SURVEY_CAMPAIGN_ID)
  );
}
